/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Isimmigrant1Inputs */

const en__field_isimmigrant1 = /** @type {(inputs: _Field_Isimmigrant1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immigration background`)
};

const de__field_isimmigrant1 = /** @type {(inputs: _Field_Isimmigrant1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuwanderungsgeschichte`)
};

/**
* | output |
* | --- |
* | "Immigration background" |
*
* @param {_Field_Isimmigrant1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_isimmigrant1 = /** @type {((inputs?: _Field_Isimmigrant1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Isimmigrant1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_isimmigrant1(inputs)
	return de__field_isimmigrant1(inputs)
});
export { _field_isimmigrant1 as "_field_isImmigrant" }